/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiation-session.reducer';

export const RadiationSessionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiationSessionEntity = useAppSelector(state => state.radiationSession.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiationSessionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiationSession.detail.title">RadiationSession</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiationSession.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.radiationSession.name">Name</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.radiationSession.description">Description</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.description}</dd>
          <dt>
            <span id="totalDose">
              <Translate contentKey="tinyMedicRestApp.radiationSession.totalDose">Total Dose</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.totalDose}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiationSession.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiationSession.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiationSession.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiationSession.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiationSession.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiationSessionEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.radiation">Radiation</Translate>
          </dt>
          <dd>{radiationSessionEntity.radiation ? radiationSessionEntity.radiation.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.frequency">Frequency</Translate>
          </dt>
          <dd>{radiationSessionEntity.frequency ? radiationSessionEntity.frequency.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.sequence">Sequence</Translate>
          </dt>
          <dd>{radiationSessionEntity.sequence ? radiationSessionEntity.sequence.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.dose">Dose</Translate>
          </dt>
          <dd>{radiationSessionEntity.dose ? radiationSessionEntity.dose.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.fractionationScheme">Fractionation Scheme</Translate>
          </dt>
          <dd>{radiationSessionEntity.fractionationScheme ? radiationSessionEntity.fractionationScheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.targetVolume">Target Volume</Translate>
          </dt>
          <dd>{radiationSessionEntity.targetVolume ? radiationSessionEntity.targetVolume.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.organ">Organ</Translate>
          </dt>
          <dd>
            {radiationSessionEntity.organs
              ? radiationSessionEntity.organs.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationSessionEntity.organs && i === radiationSessionEntity.organs.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.constraint">Constraint</Translate>
          </dt>
          <dd>
            {radiationSessionEntity.constraints
              ? radiationSessionEntity.constraints.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationSessionEntity.constraints && i === radiationSessionEntity.constraints.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationSession.cycle">Cycle</Translate>
          </dt>
          <dd>{radiationSessionEntity.cycle ? radiationSessionEntity.cycle.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/radiation-session" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiation-session/${radiationSessionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiationSessionDetail;
